const getFormattedPercentile = (percentile: string) => {
    const result = Number.parseFloat(percentile)
        ?.toFixed(2)
        .replace(/\.00$/, "");

    return result;
};

export default getFormattedPercentile;
